import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const ShippingPolicy = () => {
  return (
    <div className="pp-page">
      <div className="pp-wrapper">
        {/* Header */}
        <div className="pp-header-section">
          <h1 className="pp-main-title">Shipping Policy</h1>
        </div>

        {/* Introduction */}
        <section className="pp-content-section">
          <p className="pp-intro-text">
            At Kitty n Mice, we make sure your little one's outfits reach you
            safely and on time.
          </p>
        </section>

        {/* Order Processing */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">1. Order Processing</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              All orders are processed within 1-2 business days after
              confirmation.
            </li>
            <li className="pp-list-item">
              Orders placed on weekends or public holidays will be processed on
              the next working day.
            </li>
          </ul>
        </section>

        {/* Shipping & Delivery */}
        <section className="pp-content-section pp-highlight-box">
          <h2 className="pp-section-title">2. Shipping & Delivery</h2>
          <div className="pp-return-notice">
            <div className="pp-notice-icon">📦</div>
            <div className="pp-notice-text">
              <ul className="pp-list">
                <li className="pp-list-item">We ship across India.</li>
                <li className="pp-list-item">
                  Estimated delivery time is{" "}
                  <strong className="pp-bold">3-7 business days</strong>,
                  depending on your location.
                </li>
                <li className="pp-list-item">
                  Delivery timelines may vary due to weather conditions, public
                  holidays, or courier delays beyond our control.
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Shipping Charges */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">3. Shipping Charges</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Shipping charges (if applicable) will be calculated and displayed
              at checkout.
            </li>
            <li className="pp-list-item">
              Any ongoing free shipping offers will be mentioned on the website
              or Instagram page.
            </li>
          </ul>
        </section>

        {/* Order Tracking */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">4. Order Tracking</h2>
          <p className="pp-text">
            Once your order is shipped, you will receive a tracking link via
            SMS, email, or WhatsApp to follow your package.
          </p>
        </section>

        {/* Incorrect Address */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">
            5. Incorrect Address or Delivery Issues
          </h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Please ensure your shipping address and contact details are
              accurate at checkout.
            </li>
            <li className="pp-list-item">
              Kitty n Mice is not responsible for delays or non-delivery due to
              incorrect or incomplete address details provided by the customer.
            </li>
          </ul>
        </section>

        {/* Delays & Exceptions */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">6. Delays & Exceptions</h2>
          <p className="pp-text">
            While we strive to deliver on time, unforeseen circumstances such as
            courier delays, natural disruptions, or high-volume periods may
            impact delivery timelines. We appreciate your patience in such
            cases.
          </p>
        </section>

        {/* Contact */}
        <section className="pp-content-section pp-contact-box">
          <h2 className="pp-section-title">Need Help?</h2>
          <p className="pp-text">
            For any shipping-related queries, feel free to reach out to us and
            we'll be happy to assist you.
          </p>
          <div className="pp-contact-grid">
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Email:</strong>
              <a href="mailto:kittynmice00@gmail.com" className="pp-link">
                kittynmice00@gmail.com
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Phone:</strong>
              <a href="tel:+918076217714" className="pp-link">
                +91 80762 17714
              </a>
            </div>
          </div>
        </section>

        {/* Footer Links */}
        <div className="pp-footer-section">
          <p className="pp-footer-text">Related Policies:</p>
          <div className="pp-footer-links">
            <Link to="/privacy" className="pp-footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="pp-footer-link">
              Terms & Conditions
            </Link>
            <Link to="/refund-policy" className="pp-footer-link">
              Return Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
